import styled from 'styled-components';
import { BodyBoldS, BodyRegularS } from '../../styles/globals';
import { IThemeProvider, ITheme } from '../../styles/theme';

interface ICategoryDetailsCont {
  color: string;
  theme: ITheme;
}

export const CategoryDetailsCont = styled.div<ICategoryDetailsCont>`
  display: flex;
  flex-direction: column;
  ${({ theme, color }: ICategoryDetailsCont) => `
    background: ${theme.colors.neutral.primary[0]};
    box-shadow: 0px 1px 1px ${theme.colors.neutral.primary[40]};
    border-radius: 10px;
    border-left: 6px solid ${color};
    margin: ${theme.layout.spacing.centy} 0 0 0;
  `}
`;

interface ICategoryHeader {
  isExpanded: boolean;
  theme: ITheme;
}

export const CategoryHeader = styled.div<ICategoryHeader>`
  display: flex;
  flex-direction: column;
  ${({ isExpanded }: ICategoryHeader) => `
    margin: ${isExpanded ? '16px 16px 16px 28px' : '16px 16px 16px 28px'};
  `}
`;

export const CategoryTitleCont = styled.div`
  display: flex;
  align-items: baseline;
  cursor: pointer;
`;

export const CategoryTitle = styled.div`
  font-size: 22px;
  font-weight: 600;
  line-height: 30px;
  margin: 0 0 8px 0;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
  `}
`;

export const CloseOpenIconCont = styled.div`
  cursor: pointer;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 24px;
  height: 24px;

  svg {
    width: 9px;
    height: 18px;
  }
`;

export const NumberOfImprovementCont = styled(BodyRegularS)`
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
  `}
`;

export const NumberOfImprovement = styled(BodyBoldS)`
  margin-left: 5px;
  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
  `}
`;

export const RecommendationsCont = styled.div`
  display: flex;
  flex-direction: column;
`;
